import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeToggle } from '@/theme/ThemeToggle';
import { LanguageSwitcher } from '../LanguageSwitcher';

/**
 * Theme and language, inside the drawer (the proposal board "Telefono · menu", § Preferenze).
 *
 * On a phone the header has room for the symbol, the screen title, the search and the bell, and
 * no more, so `shell.css` takes the two display preferences out of it below 620px. They are MOVED
 * here rather than removed: the standard's rule for a header that does not fit removes an element
 * only when nothing is lost, and a phone user must still be able to switch to the dark theme.
 *
 * Shown at every drawer width, including the 620–899px band whose header still carries both. A
 * portalled drawer has no container to ask which band opened it, and the same two controls in two
 * places is the lesser failure next to a phone with no way to change its language.
 *
 * The visible names are `aria-hidden` because each control already carries the same name as its
 * own group or trigger label; a screen reader would otherwise hear every name twice.
 */
export function DrawerPreferences() {
  const { t } = useTranslation('shell');
  const { t: tProfile } = useTranslation('profile');
  const headingId = useId();

  return (
    <section className="drawer-prefs" aria-labelledby={headingId}>
      <h3 className="drawer-section-label" id={headingId}>
        {t('nav.preferences')}
      </h3>
      <div className="drawer-pref">
        <span aria-hidden="true">{t('theme.groupLabel')}</span>
        <ThemeToggle size="touch" />
      </div>
      <div className="drawer-pref">
        <span aria-hidden="true">{tProfile('language.title')}</span>
        <LanguageSwitcher size="touch" />
      </div>
    </section>
  );
}
